var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-header"},[_c('mt-header',{staticStyle:{"background":"#E60202","color":"#fff","position":"fixed","left":"0","top":"0","z-index":"99999","width":"100%","height":"33px"}},[_c('router-link',{attrs:{"slot":"left","to":_vm.backAddr},slot:"left"},[_c('mt-button',{attrs:{"icon":"back"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5026aac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/back-header.vue
// module id = null
// module chunks = 